export default __webpack_public_path__ + "static/media/94t.8455e41b.jpg";